import { coreInitiativesCommentsAddSyncSlice } from './add';
import { coreInitiativesCommentsGetAsyncSlice } from './get';
import { coreInitiativesCommentsPostAsyncSlice } from './post';
import { coreInitiativesCommentsRemoveSyncSlice } from './remove';
import { coreInitiativesCommentsUpdateSyncSlice } from './update';
import { InitiativeComment } from '@types';
import { PaginatedResource } from '@sonar-software/sonar-ts-types';

import { AsyncState, combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';
import { combineReducers, Reducer } from 'redux';
import { coreInitiativesCommentsByIdReducers, coreInitiativesCommentsByIdWatchers } from './_id';

export const coreInitiativesCommentsReducers = combineReducers({
	byId: coreInitiativesCommentsByIdReducers,
	get: joinCollectionReducers([
		coreInitiativesCommentsGetAsyncSlice.asyncReducers,
		coreInitiativesCommentsAddSyncSlice.syncReducer,
		coreInitiativesCommentsRemoveSyncSlice.syncReducer,
		coreInitiativesCommentsUpdateSyncSlice.syncReducer
	], coreInitiativesCommentsGetAsyncSlice.asyncState) as
		Reducer<AsyncState<PaginatedResource<InitiativeComment>>>,
	post: coreInitiativesCommentsPostAsyncSlice.asyncReducers
});

export const coreInitiativesCommentsWatchers = combineAllWatchers([
	coreInitiativesCommentsByIdWatchers,
	coreInitiativesCommentsGetAsyncSlice.asyncWatchers,
	coreInitiativesCommentsPostAsyncSlice.asyncWatchers
]);
